// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #4361ee;
    --bg-light: #f8f9fa;
    --text-dark: #2b2d42;
    --danger: #ef233c;
    --success: #2b9348;
}

.table_card {
    overflow-x: auto;
}

.filter_bar {
    background: white;
    padding: 12px 20px;
    border-radius: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    border: 1px solid #edf2f7;
}

.search_group {
    display: flex;
    align-items: center;
    background: #f8f9fa;
    padding: 10px 16px;
    border-radius: 12px;
    flex: 2 1;
    min-width: 250px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
}

.search_icon {
    color: #adb5bd;
    margin-right: 10px;
    font-size: 1.1rem;
}

.search_group input {
    border: none;
    background: transparent;
    outline: none;
    width: 100%;
    font-size: 0.95rem;
    color: var(--text-dark);
}

.search_group:focus-within {
    background: white;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
}

.filter_actions {
    display: flex;
    gap: 10px;
    flex: 1 1;
    min-width: 300px;
}

.custom_select {
    border-radius: 12px !important;
    border: 1px solid #e9ecef !important;
    background-color: #f8f9fa !important;
    font-size: 0.9rem !important;
    height: 45px;
    cursor: pointer;
}

.btn_reset {
    background: #fff;
    border: 1px solid #dee2e6;
    color: #6c757d;
    padding: 0 20px;
    border-radius: 12px;
    font-size: 0.9rem;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s;
    cursor: pointer;
}

.btn_reset:hover {
    background: #f1f3f5;
    color: var(--danger);
    border-color: var(--danger);
}

@media (max-width: 768px) {
    .filter_bar {
        padding: 15px;
        border-radius: 12px;
    }

    .search_group {
        flex: 1 1 100%;
    }

    .filter_actions {
        flex: 1 1 100%;
    }

    .custom_select {
        flex: 1 1;
    }
}

.email-container-compact {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 150px;
}

.email-main {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: lowercase;
}

.badge-more {
    background: #e9ecef;
    color: #495057;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: bold;
    border: 1px solid #dee2e6;
    cursor: pointer;
}

.mini-mail-popover {
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    min-width: 200px;
    border-radius: 12px;
    z-index: 1000;
    border: 1px solid #eee;
    padding: 10px;
}

.popover-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px;
    border-bottom: 1px solid #f8f9fa;
    font-size: 0.85rem;
}

.badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 12px;
    border-radius: 6px;
    font-weight: 500;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.alert-remove {
    cursor: pointer;
    opacity: 0.6;
    transition: 0.2s;
}

.alert-remove:hover {
    opacity: 1;
    transform: scale(1.2);
}

.custom_table thead th {
    border: none;
    color: #6c757d;
    font-size: 12px;
    text-transform: uppercase;
    padding: 15px;
}

.custom_table tbody td {
    vertical-align: middle;
    padding: 15px;
    border: none;
}

.btn-add-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    min-width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px dashed #ccc;
    background: transparent;
    color: #666;
    transition: all 0.2s;
    cursor: pointer;
}

.btn-add-circle:hover {
    border-color: #0d6efd;
    color: #0d6efd;
    background: #f0f7ff;
}

.grid-2-columns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.alert-tile {
    background: white;
    border: 2px solid #edf2f7;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.alert-tile:hover {
    border-color: var(--primary);
    background: #f0f4ff;
}

.alert-tile.active {
    background: var(--primary);
    border-color: var(--primary);
    color: white;
}

.sticky-top {
    z-index: 1;
    align-self: flex-start;
}

.animate-slide-in {
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.alerts_grid_cell {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: flex-start;
    align-items: center;
    max-width: 250px;
}

.alert_badge_modern {
    display: inline-flex;
    align-items: center;
    padding: 2px 2px 2px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
}

.badge_text {
    margin-right: 4px;
}

.alert_close_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.1);
    border: none;
    color: inherit;
    border-radius: 4px;
    padding: 2px;
    cursor: pointer;
    transition: background 0.2s;
}

.alert_close_btn:hover {
    background: rgba(0, 0, 0, 0.2);
    transform: scale(1.1);
}

.alert_close_btn svg {
    font-size: 12px;
}

.bg-warning {
    background-color: #fff3cd !important;
    color: #856404 !important;
}

.bg-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}

.bg-info {
    background-color: #d1ecf1 !important;
    color: #0c5460 !important;
}

.bg-secondary {
    background-color: #e2e3e5 !important;
    color: #383d41 !important;
}

.toast.hide {
    display: none;
    opacity: 0;
}

.toast.show {
    display: block;
    opacity: 1;
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.toast-container {
    margin-bottom: 20px;
    margin-right: 20px;
}

.bg-primary-soft {
    background-color: rgba(67, 97, 238, 0.1);
}

.alert-tile.active {
    background-color: var(--primary);
    border-color: var(--primary);
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(67, 97, 238, 0.2);
}

.btn-outline-success:hover {
    background-color: #2b9348;
    color: white;
}

.btn-outline-secondary:hover {
    background-color: #6c757d;
    color: white;
}

.animate-slide-in {
    animation: fadeInRight 0.4s ease-out;
}

@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translateX(30px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.btn-outline-danger {
    border-color: #ef233c;
    color: #ef233c;
    background: white;
    font-weight: 500;
}

.btn-outline-danger:hover {
    background-color: #ef233c;
    color: white;
    box-shadow: 0 4px 10px rgba(239, 35, 60, 0.2);
}

.btn-outline-danger:disabled {
    border-color: #dee2e6;
    color: #adb5bd;
}`, "",{"version":3,"sources":["webpack://./src/style/alertPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,SAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,oCAAoC;IACpC,4BAA4B;IAC5B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAO;IACX;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,YAAY;IACZ,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[":root {\n    --primary: #4361ee;\n    --bg-light: #f8f9fa;\n    --text-dark: #2b2d42;\n    --danger: #ef233c;\n    --success: #2b9348;\n}\n\n.table_card {\n    overflow-x: auto;\n}\n\n.filter_bar {\n    background: white;\n    padding: 12px 20px;\n    border-radius: 16px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n    border: 1px solid #edf2f7;\n}\n\n.search_group {\n    display: flex;\n    align-items: center;\n    background: #f8f9fa;\n    padding: 10px 16px;\n    border-radius: 12px;\n    flex: 2;\n    min-width: 250px;\n    border: 1px solid #e9ecef;\n    transition: all 0.3s ease;\n}\n\n.search_icon {\n    color: #adb5bd;\n    margin-right: 10px;\n    font-size: 1.1rem;\n}\n\n.search_group input {\n    border: none;\n    background: transparent;\n    outline: none;\n    width: 100%;\n    font-size: 0.95rem;\n    color: var(--text-dark);\n}\n\n.search_group:focus-within {\n    background: white;\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);\n}\n\n.filter_actions {\n    display: flex;\n    gap: 10px;\n    flex: 1;\n    min-width: 300px;\n}\n\n.custom_select {\n    border-radius: 12px !important;\n    border: 1px solid #e9ecef !important;\n    background-color: #f8f9fa !important;\n    font-size: 0.9rem !important;\n    height: 45px;\n    cursor: pointer;\n}\n\n.btn_reset {\n    background: #fff;\n    border: 1px solid #dee2e6;\n    color: #6c757d;\n    padding: 0 20px;\n    border-radius: 12px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    white-space: nowrap;\n    transition: all 0.2s;\n    cursor: pointer;\n}\n\n.btn_reset:hover {\n    background: #f1f3f5;\n    color: var(--danger);\n    border-color: var(--danger);\n}\n\n@media (max-width: 768px) {\n    .filter_bar {\n        padding: 15px;\n        border-radius: 12px;\n    }\n\n    .search_group {\n        flex: 1 1 100%;\n    }\n\n    .filter_actions {\n        flex: 1 1 100%;\n    }\n\n    .custom_select {\n        flex: 1;\n    }\n}\n\n.email-container-compact {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 150px;\n}\n\n.email-main {\n    max-width: 100px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: lowercase;\n}\n\n.badge-more {\n    background: #e9ecef;\n    color: #495057;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: bold;\n    border: 1px solid #dee2e6;\n    cursor: pointer;\n}\n\n.mini-mail-popover {\n    position: absolute;\n    bottom: 120%;\n    left: 50%;\n    transform: translateX(-50%);\n    background: white;\n    min-width: 200px;\n    border-radius: 12px;\n    z-index: 1000;\n    border: 1px solid #eee;\n    padding: 10px;\n}\n\n.popover-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 8px;\n    border-bottom: 1px solid #f8f9fa;\n    font-size: 0.85rem;\n}\n\n.badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 6px 12px;\n    border-radius: 6px;\n    font-weight: 500;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.alert-remove {\n    cursor: pointer;\n    opacity: 0.6;\n    transition: 0.2s;\n}\n\n.alert-remove:hover {\n    opacity: 1;\n    transform: scale(1.2);\n}\n\n.custom_table thead th {\n    border: none;\n    color: #6c757d;\n    font-size: 12px;\n    text-transform: uppercase;\n    padding: 15px;\n}\n\n.custom_table tbody td {\n    vertical-align: middle;\n    padding: 15px;\n    border: none;\n}\n\n.btn-add-circle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    min-width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    border: 1px dashed #ccc;\n    background: transparent;\n    color: #666;\n    transition: all 0.2s;\n    cursor: pointer;\n}\n\n.btn-add-circle:hover {\n    border-color: #0d6efd;\n    color: #0d6efd;\n    background: #f0f7ff;\n}\n\n.grid-2-columns {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n\n.alert-tile {\n    background: white;\n    border: 2px solid #edf2f7;\n    padding: 10px;\n    border-radius: 10px;\n    text-align: center;\n    cursor: pointer;\n    font-size: 0.75rem;\n    font-weight: 600;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.alert-tile:hover {\n    border-color: var(--primary);\n    background: #f0f4ff;\n}\n\n.alert-tile.active {\n    background: var(--primary);\n    border-color: var(--primary);\n    color: white;\n}\n\n.sticky-top {\n    z-index: 1;\n    align-self: flex-start;\n}\n\n.animate-slide-in {\n    animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateX(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.alerts_grid_cell {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    justify-content: flex-start;\n    align-items: center;\n    max-width: 250px;\n}\n\n.alert_badge_modern {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 2px 2px 10px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease;\n}\n\n.badge_text {\n    margin-right: 4px;\n}\n\n.alert_close_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.1);\n    border: none;\n    color: inherit;\n    border-radius: 4px;\n    padding: 2px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.alert_close_btn:hover {\n    background: rgba(0, 0, 0, 0.2);\n    transform: scale(1.1);\n}\n\n.alert_close_btn svg {\n    font-size: 12px;\n}\n\n.bg-warning {\n    background-color: #fff3cd !important;\n    color: #856404 !important;\n}\n\n.bg-danger {\n    background-color: #f8d7da !important;\n    color: #721c24 !important;\n}\n\n.bg-info {\n    background-color: #d1ecf1 !important;\n    color: #0c5460 !important;\n}\n\n.bg-secondary {\n    background-color: #e2e3e5 !important;\n    color: #383d41 !important;\n}\n\n.toast.hide {\n    display: none;\n    opacity: 0;\n}\n\n.toast.show {\n    display: block;\n    opacity: 1;\n    animation: slideInRight 0.3s ease-out;\n}\n\n@keyframes slideInRight {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n.toast-container {\n    margin-bottom: 20px;\n    margin-right: 20px;\n}\n\n.bg-primary-soft {\n    background-color: rgba(67, 97, 238, 0.1);\n}\n\n.alert-tile.active {\n    background-color: var(--primary);\n    border-color: var(--primary);\n    color: white;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(67, 97, 238, 0.2);\n}\n\n.btn-outline-success:hover {\n    background-color: #2b9348;\n    color: white;\n}\n\n.btn-outline-secondary:hover {\n    background-color: #6c757d;\n    color: white;\n}\n\n.animate-slide-in {\n    animation: fadeInRight 0.4s ease-out;\n}\n\n@keyframes fadeInRight {\n    from {\n        opacity: 0;\n        transform: translateX(30px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.btn-outline-danger {\n    border-color: #ef233c;\n    color: #ef233c;\n    background: white;\n    font-weight: 500;\n}\n\n.btn-outline-danger:hover {\n    background-color: #ef233c;\n    color: white;\n    box-shadow: 0 4px 10px rgba(239, 35, 60, 0.2);\n}\n\n.btn-outline-danger:disabled {\n    border-color: #dee2e6;\n    color: #adb5bd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
